import { ancestors } from "@broadpaper/core";
import { useSession, useEditorState, nodeLabel } from "../state/context.js";
import { Icon } from "../ui/icons.js";

export function Breadcrumb() {
  const session = useSession();
  const selection = useEditorState((s) => s.selection);
  const version = useEditorState((s) => s.version);
  void version;
  const id = selection[0];
  if (!id) return <div className="bpe-breadcrumb bpe-muted">Select a block to edit it, or drag one in from the left.</div>;
  const chain = ancestors(session.store.index(), id);
  const regionEntry = chain[0];
  const regionLabel = regionEntry?.region === "body" ? "Body" : regionEntry?.region.startsWith("header") ? "Header" : "Footer";
  return (
    <nav className="bpe-breadcrumb" aria-label="Selection path">
      <span className="bpe-breadcrumb__item bpe-muted">{regionLabel}</span>
      {chain.map((e, i) => (
        <span key={e.node.id} style={{ display: "contents" }}>
          <Icon name="chevron-right" size={11} className="bpe-breadcrumb__sep" />
          <button type="button" className={`bpe-breadcrumb__item ${i === chain.length - 1 ? "bpe-breadcrumb__item--current" : ""}`} onClick={() => session.store.select([e.node.id])}>
            <Icon name={session.registry.get(e.node.type)?.icon ?? "box"} size={11} />
            {nodeLabel(session, e.node)}
          </button>
        </span>
      ))}
      {selection.length > 1 ? <span className="bpe-badge bpe-badge--accent">+{selection.length - 1} more</span> : null}
    </nav>
  );
}
